import { SSRProvider } from 'react-bootstrap'
import { IntlProvider } from 'react-intl'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import i18nConfig from './i18n-config'

import 'swp-components/lib/assets/styles/lib.css'

const cache = createCache({ key: 'swp' })

export const wrapPageElement = ({ props, element }) => {
  let locale = props.pageContext.locale ?? i18nConfig.defaultLocale
  let messages = {
    ...require(`swp-components/lib/assets/translations/${locale}.json`),
    ...require(`./src/translations/${locale}.json`),
  }

  return (
    <SSRProvider {...props}>
      <CacheProvider value={cache}>
        <IntlProvider locale={locale} messages={messages}>
          {element}
        </IntlProvider>
      </CacheProvider>
    </SSRProvider>
  )
}
